const LocationIcon = ({
  size = 24,
  color = '#3B82F6',
  strokeWidth = 2,
  className = '',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M21 10C21 17 12 23 12 23S3 17 3 10C3 5.02944 7.02944 1 12 1C16.9706 1 21 5.02944 21 10Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={`${color}20`} // 20% opacity of the color
      />
      <circle
        cx="12"
        cy="10"
        r="3"
        stroke={color}
        strokeWidth={strokeWidth}
        fill={color}
      />
    </svg>
  );
};

export default LocationIcon;